import IDimensions from '../../../../common/model/IDimensions';
import { financeFormInputStorage } from '../../../../common/service/financeFormInputStorage';
import {
  financeFormInputVar,
  selectedCarNextFiltersVar,
  selectedFeaturesIdVar,
  selectedFeaturesInputVar,
} from '../graphql/cache';
import { FinanceFormInput } from '../../../__generated__/globalTypes';
import { FinanceFormType } from '../../__generated__/globalTypes';
import { SelectedFeaturesInputVarDefaultValue } from '../../gqlCustomise/model/ISelectedFeaturesInputVar';

const reactiveVarsService = {
  resetSelectedFeaturesIds: () => {
    selectedFeaturesIdVar([]);
    selectedFeaturesInputVar(SelectedFeaturesInputVarDefaultValue);
  },
  resetFinanceFormInput: (dimensions: IDimensions) => {
    const financeFormInputCash: FinanceFormInput = { paymentType: FinanceFormType.cash };
    financeFormInputVar(financeFormInputCash);
    financeFormInputStorage.save(dimensions, financeFormInputCash);
  },
  resetSelectedCarNextFilters: () => selectedCarNextFiltersVar(null),
};

export default reactiveVarsService;
